module.exports = require("./uz-Cyrl-UZ");